import {
    useEffect,
    useRef,
    useState,
    ChangeEvent,
    ComponentProps,
  } from 'react';
  import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch-hooks-web';
  import debounce from 'lodash.debounce';
  
  import { ControlledSearchBox } from './controlledSearchBox';
  
  export type SearchBoxProps = ComponentProps<'div'> & UseSearchBoxProps;
  
  export function CustomSearchBox(props: any) {
    const { query, refine, isSearchStalled } = useSearchBox(props);
    const inputRef = useRef<HTMLInputElement>(null);
    const [inputValue, setInputValue] = useState(props?.searchQuery || '');

    function onReset() {
        setInputValue('');
        props?.setSearchQuery('');
    }
    const debouncedSetSearchQuery = useRef(
      debounce((value: string) => {
        props?.setSearchQuery(value);
      }, 400)
    ).current;

    useEffect(() => {
      debouncedSetSearchQuery(inputValue);
    }, [inputValue, debouncedSetSearchQuery]);

    useEffect(() => {
      if (query !== props?.searchQuery) {
        refine(props?.searchQuery);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.searchQuery, refine, query]);

    function onChange(event: ChangeEvent<HTMLInputElement>) {
      setInputValue(event?.currentTarget?.value);
    }
  
    return (
      <ControlledSearchBox
        className='relative border-b border-[#333]'
        inputRef={inputRef}
        isSearchStalled={isSearchStalled}
        onChange={onChange}
        onReset={onReset}
        placeholder={props?.placeholder}
        value={inputValue}
        onFocus={props?.onFocus}
        onBlur={props?.onBlur}
        onSubmit={props?.onSubmit}
        onKeyDown={props?.onKeyDown}
      />
      
    );
  }
